import type { LoadDevicesFailed, LoadDevicesRequest, LoadDevicesSucceeded, LoadDeviceStatusSuccess } from './actions';
import { DevicesActionTypes } from './actionTypes';

import type { UUID } from '@cobliteam/common-types';

import type { DeviceFragment } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { DeviceStatusEvent } from '@cobliteam/api-lib/src/dashboard/device/definitions/Types';

export const loadDevicesRequest = (vehicleGroupIds?: UUID[]): LoadDevicesRequest => ({
  type: DevicesActionTypes.LOAD_DEVICES_REQUEST,
  payload: { vehicleGroupIds },
});

export const loadDevicesSucceeded = (drivers: DeviceFragment[]): LoadDevicesSucceeded => ({
  type: DevicesActionTypes.LOAD_DEVICES_SUCCEEDED,
  payload: drivers,
});

export const loadDevicesFailed = (): LoadDevicesFailed => ({
  type: DevicesActionTypes.LOAD_DEVICES_FAILED,
});

export const loadDeviceStatusSuccess = (payload: DeviceStatusEvent[]): LoadDeviceStatusSuccess => ({
  type: DevicesActionTypes.LOAD_DEVICE_STATUS_SUCCESS,
  payload,
});
